import React from 'react';
import logo from './logo.svg';
import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/600.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/800.css';
import Pagina from "./Pagina/Pagina";
import {Grid} from "@mui/material";

function App() {
  return (
      <Grid
          container
          justifyContent={'flex-start'}
          alignItems={'flex-start'}
          size={{xs: 12, sm: 12, md: 12}}>
        <Pagina/>

      </Grid>
  );
}

export default App;
